import { render, staticRenderFns } from "./CreateItemModal.vue?vue&type=template&id=83d7d13a&scoped=true&"
import script from "./CreateItemModal.vue?vue&type=script&lang=js&"
export * from "./CreateItemModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateItemModal.vue?vue&type=style&index=0&id=83d7d13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d7d13a",
  null
  
)

export default component.exports